<template>
  <b-modal
    v-model="localActive"
    :dialog-class="`s-modal ${className}`"
    centered
    hide-header
    hide-footer
    @hidden="close"
  >
    <div
      class="modal-frame"
      :class="{
        'full-height': fullHeight,
        'disable-scroll': disableScroll,
      }"
    >
      <div class="modal-close">
        <svg
          class="close-icon"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="close"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
      </div>
      <div class="modal-wrapper">
        <shadow-scroll-container ref="track" class="modal-track" :with-top-scroller="true" :disabled="disableScroll">
          <div class="modal-padding">
            <div v-if="title" class="modal-frame__header">
              <div>
                <h2 class="modal-frame__title" v-html="title"></h2>
                <slot name="subtitle"></slot>
              </div>
            </div>

            <slot></slot>
          </div>
        </shadow-scroll-container>
      </div>
      <div v-if="!hideFooter" class="modal-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ShadowScrollContainer from "@/components/shadow-scroll-container";

export default {
  components: {
    ShadowScrollContainer,
  },
  props: ["active", "title", "hideHeader", "hideFooter", "fullHeight", "className", "disableScroll"],
  data() {
    return {
      localActive: false,
    };
  },
  watch: {
    active(v) {
      this.localActive = v;
    },
  },

  methods: {
    close() {
      this.localActive = false;

      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

/deep/ {
  .modal {
    &-body {
      padding: 0 !important;
      border-radius: inherit;
    }
    &-content {
      height: auto;
    }
    &-close {
      padding-bottom: 0!important;
    }
  }

  .modal-frame {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: inherit;

    &__header {
      margin-bottom: 20px;
    }

    &__title {
      margin-bottom: 0px;
      font-size: 15px;
      font-weight: 500;
    }

    @include bootstrapMd {
      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      &__title {
        font-size: 18px;
      }
    }
  }
}

.modal-close {
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.modal-wrapper {
  flex-grow: 1;
  display: flex;
  overflow: hidden;
}

.modal-track {
  width: 100%;

  /deep/ {
    .scroll-container {
      padding-right: 0;
    }
  }
}

.modal-padding {
  padding: 0 20px 20px;
}

.modal-actions {
  flex-shrink: 0;
  background: white;
  display: flex;
  border-top: none !important;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}

.modal-frame {
  &.disable-scroll {
    overflow: visible;

    .modal-wrapper {
      overflow: visible;
    }
  }
}

@include beforeBootstrapMd {
  .modal-frame {
    max-height: 100vh;
    &.full-height {
      height: 100vh;
    }
  }

  .modal-actions {
    /deep/ {
      button {
        flex-basis: 100%;
        width: 100%;
        border-radius: 0;
        flex-shrink: 1;
      }
    }
  }
}

@include bootstrapMd {
  .modal-padding {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 15px;
    padding-top: 5px;
  }

  .modal-actions {
    align-items: center;
    justify-content: flex-end;
    padding: 10px 30px 30px;

    /deep/ {
      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
